import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PermitType } from "@ha/data/basic";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Navigate } from "@ngxs/router-plugin";
import { Store } from "@ngxs/store";
import { take } from "rxjs/operators";

import { PermitPaths } from "../../../permit-paths";
import { PermitCreateService } from "../../services/permit-create.service";

@UntilDestroy()
@Component({
    selector: "pmt-permit-handle-flammable-atex-request",
    templateUrl: "./permit-handle-flammable-atex-request.component.html",
    styleUrls: ["./permit-handle-flammable-atex-request.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitHandleFlammableAtexRequestComponent implements OnInit {
    public loading = true;
    public hasError = false;

    constructor(
        private route: ActivatedRoute,
        private permitCreateService: PermitCreateService,
        private store: Store,
        private cdr: ChangeDetectorRef,
    ) {}

    public ngOnInit(): void {
        const permitIdParam = this.route.snapshot.paramMap.get("permitId") ?? "";
        const hotWorkPermitId = parseInt(permitIdParam, 10);
        const isDemo = this.route.snapshot.queryParamMap.get("isDemo") === "true";

        if (isNaN(hotWorkPermitId) || hotWorkPermitId <= 0) {
            this.openRequestList();
            return;
        }

        this.permitCreateService.createPermit({
            isPremium: true,
            isDemo: isDemo,
            permitType: PermitType.flammableAtex,
            hotWorkPermitId: hotWorkPermitId,
        }).pipe(take(1), untilDestroyed(this)).subscribe({
            next: (result) => {
                if (result.success === true && result.newPermitId > 0) {
                    this.store.dispatch(new Navigate(
                        [PermitPaths.Root, result.newPermitId.toString()],
                        { returnAfterStarted: true },
                    ));
                    return;
                }

                this.hasError = true;
                this.loading = false;
                this.cdr.markForCheck();
            },
            error: () => {
                this.hasError = true;
                this.loading = false;
                this.cdr.markForCheck();
            },
        });
    }

    public openRequestList(): void {
        this.store.dispatch(new Navigate([PermitPaths.Root, PermitPaths.PermitRequests]));
    }
}
